import en from '../translation/en.json'
import id from '../translation/id.json'
import GeneralParticle from '@evos/general-particle'

const { Utils } = GeneralParticle

export default (key: string, option: any) => {
  return Utils.T({ en, id }, key, option)
}
